import { render, staticRenderFns } from "./InvAgingForwardViewNew.vue?vue&type=template&id=e400eb64&scoped=true&"
import script from "./InvAgingForwardViewNew.vue?vue&type=script&lang=js&"
export * from "./InvAgingForwardViewNew.vue?vue&type=script&lang=js&"
import style0 from "./InvAgingForwardViewNew.vue?vue&type=style&index=0&id=e400eb64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e400eb64",
  null
  
)

export default component.exports